import React, { forwardRef } from 'react'
import { InputNumber } from '@ow/comps'

const Render = function ({ opts = {}, onChange, value }, ref) {
  const { unit } = opts

  const props = {}
  if (opts.rangeSetting) {
    if (opts.min || opts.min === 0) {
      props.min = opts.min
    } else {
      props.min = null
    }
    if (opts.max || opts.max === 0) {
      props.max = opts.max
    } else {
      props.max = null
    }
  }
  if (opts.decimalDigits || opts.decimalDigits === 0) {
    props.precision = opts.decimalDigits
  }

  return (
    <div className="relative flex flex-row items-center w-full">
      <InputNumber
        {...props}
        placeholder={opts.hint || opts.intro}
        readOnly={opts.readOnly || opts.readonly}
        disabled={opts.onlyShow}
        defaultValue={value}
        onChange={onChange}
        ref={ref}
      />

      {unit && (
        <span
          style={{
            fontSize: '0.75rem',
            opacity: 1,
            background: '#fff',
            right: '21px',
            padding: '5px',
            color: 'gray',
          }}
          className="absolute"
        >
          {unit}
        </span>
      )}
    </div>
  )
}

export default forwardRef(Render)
